import SButton from "components/Common/Button"
import SelectBox from "components/Common/SelectBox"
import React, { useEffect } from "react"
import { Card, CardBody, Col, Container, Input, Row } from "reactstrap"
import { useLocation, useHistory } from "react-router-dom"
import { getOrderSheetByIdAPI, putOrderSheetAPI } from "helpers/order_sheet"
import TabTourses from "./TabTourses"
import TabJacket from "./TabJacket"
import { getSpecificationListAPI } from "helpers/specification_helper"
import DimensionAPI from "helpers/dimension_backend_helper"
import correctionAPI from "helpers/correction_backend_helper"
import Breadcrumb from "components/Common/Breadcrumb"
import { useDispatch } from "react-redux"
import { resetSheetDatas } from "../../store/canvas/action"

function NewOrderSheets() {
  let location = useLocation()
  const history = useHistory()
  const dispatch = useDispatch()
  const [tabs, setTabs] = React.useState([])

  const [activeTab, setActiveTab] = React.useState(null)

  const [field, setField] = React.useState({
    hasMemo: true,
    memo: "",
    categoryName: "",
    productName: "",
    jacket: {
      specifications: [],
      dimensions: [],
      otherDimensions: [],
    },
    pants: {
      specifications: [],
      dimensions: [],
      corrections: [],
    },
  })

  // dimension
  const [dimensionTourses, setDimensionTourses] = React.useState([])
  const [dimensionJacket, setDimensionJacket] = React.useState([])
  const [dimensionOther, setDimensionOther] = React.useState([])

  // correction
  const [correction, setCorrection] = React.useState([])

  // specification
  const [specification, setSpecification] = React.useState([])

  const params = new URLSearchParams(location.search)
  const id = params.get("id")

  const fetchDataById = async () => {
    try {
      let res = await getOrderSheetByIdAPI(id)

      let _temp = []
      res.data?.forms?.forEach((v, i) => {
        _temp.push({ index: i, label: v })
      })
      setTabs(_temp)
      setActiveTab(_temp[0])

      let _field = {
        hasMemo: res.data.hasMemo === null ? false : res.data.hasMemo,
        memo: res.data.memo === null ? "" : res.data.memo,
        categoryName: res.data.categoryName || "",
        productName: res.data.productName || "",
        jacket: res.data?.jacket
          ? res.data?.jacket
          : {
              specifications: [],
              dimensions: [],
              otherDimensions: [],
            },
        pants: res.data?.pants
          ? res.data?.pants
          : {
              specifications: [],
              dimensions: [],
              corrections: [],
            },
      }
      setField(_field)

      let params = {
        categoryId: res.data.categoryId,
        productId: res.data.id,
      }

      getSpecificationListAPI(params).then(spec => {
        let option = [{ label: "-", value: "" }]
        spec.data.forEach(v => {
          option.push({
            label: v.item,
            value: v.id,
            specification: v,
          })
        })
        setSpecification(option)
      })

      correctionAPI.getList(params).then(cor => {
        let option = []
        cor.data.forEach(v => {
          option.push({
            label: v.item,
            value: v.id,
            correction: v,
          })
        })
        setCorrection(option)
      })

      // console.log("res: ", res)
    } catch (error) {
      console.log("error: ", error)
    }
  }

  useEffect(() => {
    fetchDataById()
  }, [id])

  const getDimensionTourses = () => {
    let params_dimension = {
      dimensionProductCategory: "トラウザーズ",
      frameType: "寸法枠",
    }
    DimensionAPI.getList(params_dimension).then(dim => {
      let option = []

      dim.data.forEach(v => {
        option.push({
          label: v.item,
          value: v.id,
        })
      })
      setDimensionTourses(option)
    })
  }
  const getDimensionJacket = () => {
    let params_dimension = {
      dimensionProductCategory: "ジャケット",
      frameType: "寸法枠",
    }
    DimensionAPI.getList(params_dimension).then(dim => {
      let option = []
      dim.data.forEach(v => {
        option.push({
          label: v.item,
          value: v.id,
        })
      })
      setDimensionJacket(option)
    })
  }
  const getDimensionOther = () => {
    let params_dimension = {
      dimensionProductCategory: "ジャケット",
      frameType: "その他寸法枠",
    }
    DimensionAPI.getList(params_dimension).then(dim => {
      let option = []
      dim.data.forEach(v => {
        option.push({
          label: v.item,
          value: v.id,
        })
      })
      setDimensionOther(option)
    })
  }

  useEffect(() => {
    getDimensionTourses()
    getDimensionJacket()
    getDimensionOther()
  }, [])

  // function on change handler for tab jacket
  const onChangeJacketSpec = (e, i) => {
    let jackets = { ...field?.jacket }
    let temp = [...jackets?.specifications]

    if (temp.length > 0) {
      temp[i] = { ...e.specification, formId: e?.value, sequence: i + 1 }
      if (i === temp.length - 1) {
        temp.push({
          formId: "",
          sequence: i + 1,
        })
      }
    } else {
      temp = [
        { ...e.specification, formId: e?.value, sequence: i + 1 },
        {
          formId: "",
          sequence: i + 2,
        },
      ]
    }

    jackets.specifications = temp

    setField({ ...field, jacket: jackets })
  }

  const onChangeJacketDim = (e, i) => {
    let jackets = { ...field?.jacket }
    let temp = [...jackets?.dimensions]

    if (temp.length > 0) {
      temp[i].formId = e?.value

      if (i === temp.length - 1 && e?.label && e?.value) {
        temp.push({
          formId: "",
          sequence: temp[temp.length - 1].sequence + 1,
        })
      }
    } else {
      temp = [
        {
          formId: e?.value,
          sequence: i + 1,
        },
        {
          formId: "",
          sequence: i + 2,
        },
      ]
    }
    jackets.dimensions = temp

    setField({ ...field, jacket: jackets })
  }

  const onChangeOtherJacketDim = (e, i) => {
    let jackets = { ...field?.jacket }
    let temp = [...jackets?.otherDimensions]

    if (temp.length > 0) {
      temp[i].formId = e?.value
      if (i === temp.length - 1 && e?.label && e?.value) {
        temp.push({
          formId: "",
          sequence: temp[temp.length - 1].sequence + 1,
        })
      }
    } else {
      temp = [
        {
          formId: e?.value,
          sequence: i + 1,
        },
        {
          formId: "",
          sequence: i + 2,
        },
      ]
    }
    jackets.otherDimensions = temp

    setField({ ...field, jacket: jackets })
  }

  // function on change handler for tab tourses
  const onChangeToursesDim = (e, i) => {
    let pants = { ...field?.pants }
    let temp = [...pants?.dimensions]

    if (temp.length > 0) {
      temp[i].formId = e.value
      if (i === temp.length - 1 && e.label && e.value) {
        temp.push({
          formId: "",
          sequence: temp[temp.length - 1].sequence + 1,
        })
      }
    } else {
      temp = [
        {
          formId: e?.value,
          sequence: i + 1,
        },
        {
          formId: "",
          sequence: i + 2,
        },
      ]
    }

    pants.dimensions = temp

    setField({ ...field, pants: pants })
  }

  const onChangeToursesCor = (e, i) => {
    let pants = { ...field?.pants }
    let temp = [...pants?.corrections]

    if (temp.length > 0) {
      temp[i] = { ...e.correction, formId: e.value, sequence: i + 1 }
      if (i === temp.length - 1 && e.label && e.value) {
        temp.push({
          formId: "",
          sequence: temp[temp.length - 1].sequence + 1,
        })
      }
    } else {
      temp = [
        {
          ...e.correction,
          formId: e?.value,
          sequence: i + 1,
        },
        {
          formId: "",
          sequence: i + 2,
        },
      ]
    }

    pants.corrections = temp

    setField({ ...field, pants: pants })
  }
  const onChangeToursesSpec = (e, i) => {
    let pants = { ...field?.pants }
    let temp = [...pants?.specifications]

    if (temp.length > 0) {
      temp[i] = { ...e.specification, formId: e.value, sequence: i + 1 }

      if (i === temp.length - 1 && e.label && e.value) {
        temp.push({
          formId: "",
          sequence: temp[temp.length - 1].sequence + 1,
        })
      }
    } else {
      temp = [
        {
          ...e.specification,
          formId: e?.value,
          sequence: i + 1,
        },
        {
          formId: "",
          sequence: i + 2,
        },
      ]
    }

    pants.specifications = temp

    setField({ ...field, pants: pants })
  }

  const onSubmit = () => {
    let jacketDimensions = [],
      jacketOtherDimensions = [],
      jacketSpecifications = [],
      pantsDimensions = [],
      pantsCorrections = [],
      pantsSpecifications = []

    for (const element of field.jacket.dimensions) {
      if (element.formId) {
        jacketDimensions.push(element)
      }
    }

    for (const element of field.jacket.otherDimensions) {
      if (element.formId) {
        jacketOtherDimensions.push(element)
      }
    }

    for (const element of field.jacket.specifications) {
      jacketSpecifications.push(element)
    }

    jacketSpecifications.pop()

    for (const element of field.pants.dimensions) {
      if (element.formId) {
        pantsDimensions.push(element)
      }
    }

    for (const element of field.pants.corrections) {
      if (element.formId) {
        pantsCorrections.push(element)
      }
    }

    for (const element of field.pants.specifications) {
      if (element.formId) {
        pantsSpecifications.push(element)
      }
    }

    let payload = {
      hasMemo: field.hasMemo === null ? false : field.hasMemo,
      memo: "",
      jacket: {
        ...field.jacket,
        dimensions: jacketDimensions,
        otherDimensions: jacketOtherDimensions,
        specifications: jacketSpecifications,
      },
      pants: {
        ...field.pants,
        corrections: pantsCorrections,
        dimensions: pantsDimensions,
        specifications: pantsSpecifications,
      },
    }

    putOrderSheetAPI(payload, id)
      .then(res => {
        history.push("/order-sheet-creation")
      })
      .catch(err => {
        console.log("err: ", err)
      })
  }

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumb title="オーダーシート作成" breadcrumbList={[]} />
        <Card>
          <CardBody>
            <Row className="mt-3">
              <Col xl={1} sm={2} className="align-self-center">
                <p className="mb-0">商品選択</p>
              </Col>
              <Col xl={2} sm={3}>
                <SelectBox
                  value={{
                    label: field.categoryName,
                    value: field.categoryName,
                  }}
                  isDisabled
                  label={""}
                  options={[]}
                />
              </Col>
              <Col xl={2} sm={3}>
                <SelectBox
                  value={{
                    label: field.productName,
                    value: field.productName,
                  }}
                  isDisabled
                  label={""}
                  options={[]}
                />
              </Col>
              <Col sm={1} className="align-self-center">
                <p className="mb-0">メモ欄</p>
              </Col>
              <Col sm={1} className="align-self-center">
                <Input
                  checked={field.hasMemo === true ? true : false}
                  onClick={() => setField({ ...field, hasMemo: true })}
                  className="me-2 mb-0"
                  type="radio"
                  id="あり"
                />
                <label className="mb-0" htmlFor="あり">
                  あり
                </label>
              </Col>
              <Col sm={1} className="align-self-center">
                <Input
                  checked={field.hasMemo === false ? true : false}
                  onClick={() => setField({ ...field, hasMemo: false })}
                  className="me-2 mb-0"
                  type="radio"
                  id="なし"
                />
                <label className="mb-0" htmlFor="なし">
                  なし
                </label>
              </Col>
            </Row>
            <Row className="justify-content-end mt-3">
              <Col
                xl={4}
                sm={6}
                className="d-flex justify-content-end align-content-end flex-wrap"
              >
                <SButton
                  style={{ width: 150 }}
                  className="mx-2 button"
                  onClick={() => {
                    history.push(`/order-sheet-creation/canvas?id=${id}`)
                    dispatch(resetSheetDatas())
                  }}
                >
                  手書画像管理
                </SButton>
                <SButton
                  style={{ width: 150 }}
                  className={"mx-2 button"}
                  onClick={onSubmit}
                >
                  保存
                </SButton>
              </Col>
            </Row>
          </CardBody>
        </Card>

        <div className="d-flex my-3">
          {tabs.map((v, index) => {
            return (
              <div key={index}>
                <SButton
                  style={{ width: 150, borderRadius: 0 }}
                  className={
                    activeTab.label === v.label ? "button-active" : "button"
                  }
                  onClick={() => {
                    console.log("v.index")
                    console.log(v.index)
                    setActiveTab(v)
                  }}
                >
                  {v.label}
                </SButton>
              </div>
            )
          })}
        </div>

        {activeTab?.label === "トラウザーズ" ? (
          <TabTourses
            field={field}
            correction={correction}
            specification={specification}
            dimension={dimensionTourses}
            onChangeDim={(e, i) => onChangeToursesDim(e, i)}
            onChangeCor={(e, i) => onChangeToursesCor(e, i)}
            onChangeSpec={(e, i) => onChangeToursesSpec(e, i)}
          />
        ) : (
          <TabJacket
            field={field}
            specification={specification}
            dimension={dimensionJacket}
            otherDimensions={dimensionOther}
            onChangeSpec={(e, i) => onChangeJacketSpec(e, i)}
            onChangeDim={(e, i) => onChangeJacketDim(e, i)}
            onChangeOtherDim={(e, i) => onChangeOtherJacketDim(e, i)}
          />
        )}
      </Container>
    </div>
  )
}

export default NewOrderSheets
